import { WebPlugin } from '@capacitor/core';
import { PDFGenerator } from '@awesome-cordova-plugins/pdf-generator';
export class driverlicenseWeb extends WebPlugin {
    async convertPdf(options) {
        let pdfOptions = {
            documentSize: 'A4',
            type: 'base64',
        };
        let convertResult;
        PDFGenerator.fromURL(options.imgUrl, pdfOptions).then(base64String => (convertResult = base64String));
        // var doc = new jsPDF();
        // var logo = this.getDataUri(options.imgUrl) as any;
        // doc.addImage(logo, 'jpeg', 0, 5, 50, 50);
        // doc.save('sample-file.pdf');
        return convertResult;
    }
}
//# sourceMappingURL=web.js.map